module.exports = __webpack_public_path__ + "media/images/pascal-meier-UYiesSO4FiM-unsplash-d88f104a3354ee291ae7572c2c9ce2d3.jpg";